<template>
  <div style="background-color: pink; z-index: 10">
    <div
      class="
        tooltip tooltip-table
        domestic-tooltip-table
        tooltip-content-no-scrollBar
      "
    >
      <div class="tooltip-content">
        <div>
          <table>
            <tbody>
              <tr>
                <td class="sub-tit col-2-title">碳排放量</td>
                <td>{{getTpfLowerName(cabinTypeItem.carbonIndicator)}}</td>
              </tr>
              <tr>
                <td class="sub-tit col-2-title">航线碳排放标准值(kg)</td>
                <td>
                  {{cabinTypeItem.carbonStandard}}kg
                </td>
              </tr>
              <tr>
                <td class="sub-tit col-2-title">碳排放量(kg)</td>
                <td>
					{{cabinTypeItem.carbonEmission}}kg
                </td>
              </tr>
              <tr>
                <td class="sub-tit col-2-title">同比</td>
                <td>
					<span :style="{color:cabinTypeItem.carbonReduction>0?'red':'green'}">
						{{cabinTypeItem.carbonReduction>0?'增加':'减少'}}{{ cabinTypeItem.carbonReductionRate }}%, {{cabinTypeItem.carbonReduction>0?'增加':'减少'}}{{cabinTypeItem.carbonReduction}}kg
					</span>
					
                </td>
              </tr>
              <tr>
                <td class="sub-tit col-2-title">碳排放量估算原则</td>
                <td>
                  航班的碳排放估算需涉及距离、飞机类型、平均客座率和每个舱位的座位数等因素。例如，低能耗的飞机和短途飞行所产生的碳排放量通常更少。航班"碳排放量参考值"指的是您所搜索路线的碳排放量中间值，您每次出行所选择的航班碳排放量估算值将与所在路线的中间值进行比较。
                  该估算原则适用于绝大多数航班，但对于极特殊情况下的非特定飞机类型，我们无法提供可参考的碳排数据及相应的碳排放量估算，该类航班将被标记为"未知排放"。
                </td>
              </tr>
              <tr>
                <td class="sub-tit col-2-title">碳排放量数据来源</td>
                <td>
                  自2024年2月5日，我们应用 Travalyst 全新旅行影响模型( TIM
                  )数据， travelyst 全生命周期碳排算法（ Well - to - Wake
                  ）科学计算了航空燃油的生产、采购和运输造成的温室气体影响，便于与其他交通方式进行公平比较。
                  Travalyst
                  是一个多方联盟的非营利组织，由苏塞克斯公爵发起，联盟成员包括Booking.com、
                  Skyscanner 、Trip.com Group 、 Tripadvisor 、 Visa 、 Google
                  Expedia Group
                  ，旨在为行业创建开源的框架，实现可持续旅行所需的系统性变化。旅行影响模型是基于欧洲环境署（
                  EEA ）发布的附件1.A.3.a Aviation 2023中排放估算的方法。
                  共拓事业版图共赴完美差旅
                  "旅行是拉近我们距离的有力手段﹣﹣分享我们国家的美丽和我们无数的文化，寻找我们共同的人性。但随着旅行而来的是保护我们脆弱星球的责任。我们必须确保子孙后代能够可持续地追随我们的脚步，世界及其人民能够共同成长。"
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import tkCommonTpf from './../../tkCommon/tkCommonTpf.js';
export default {
  name: "ProductRule",
  data() {
    return {};
  },
  props: {
    cabinTypeItem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
	getTpfLowerName(carbonIndicator){
		return	tkCommonTpf.getTpfForCarbonIndicatorName(carbonIndicator)
	}
  },
  watch: {
    priceItem(val) {
      // console.log(val)
    },
  },
};
</script>

<style scoped lang="scss">
.orange {
  color: orange;
}
.col-2-title{
	width: 150px;
}

.domestic-tooltip-table {
  width: 1000px;
  max-width: 1000px;
  background-color: pink;
}
.tooltip {
  padding: 15px;
  box-shadow: 0 4px 8px rgba(204, 204, 204, 0.8);
  -webkit-box-shadow: 0 4px 8px rgba(204, 204, 204, 0.8);
}

.domestic-tooltip-table.tooltip-table table {
  border: 1px solid #ddd;
  border-collapse: collapse;
  border-spacing: 0;
}
.tooltip-table.domestic-tooltip-table table .sub-table table {
  border: none;
}
.tooltip-table table td,
.tooltip-table table th {
  text-align: left;
  font-weight: 400;
  padding: 7px 10px;
  border-bottom: 1px solid #ccc;
}
.tooltip-table.domestic-tooltip-table.tooltip-table table .sub-tit,
.tooltip-table.domestic-tooltip-table.tooltip-table table .tit {
  border-right: 1px solid #ddd;
  padding: 12px;
  color: #333;
  font-size: 14px;
}
.tooltip-table table .sub-table {
  padding: 0;
  vertical-align: top;
  height: 1px;
  min-height: 100%;
}
.tooltip-table {
  display: inline-block;
  text-align: left;
  background-color: #fff;

  line-height: 1.5;
}
.tooltip-table table {
  width: 100%;
}
.tooltip-table.domestic-tooltip-table table .detail-item {
  min-width: 70px;
}
.tooltip-table table .col-1 {
  width: 130px;
  border-right: 1px solid #ccc;
}

// 底部
.tooltip-table .sub-desc.orange-desc {
  background-color: #fff8f2;
}
.tooltip-table .sub-desc {
  background: #f2fbf8;
  border-radius: 2px;
  padding: 8px 16px;
}
</style>
